import { Box } from "@mui/material";

const ContainerComponent = ({ children }) => {
  return (
    <Box>
      <img src="/vectorLeft.png" alt="Surya Logo" style={{ position: "absolute", top: 0, right: 0 }} />
      <img src="/vectorRight.png" alt="Surya Logo" style={{ position: "absolute", top: 0, left: 0 }} />
      <img src="/vectorLeftBottom.png" alt="Surya Logo" style={{ position: "absolute", bottom: 0, left: 0 }} />
      <img src="/vectorRightBottom.png" alt="Surya Logo" style={{ position: "absolute", bottom: 0, right: 0 }} />
      {children}
    </Box>
  );
};

export default ContainerComponent;
